module.exports = __webpack_public_path__ + "static/media/strutture-di-contenimento-americana-angolo-noleggiocampi.e6b3510b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/strutture-di-contenimento/americane/strutture-di-contenimento-americana-angolo-noleggiocampi.jpg
// module id = 622
// module chunks = 0